import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { FiltrosOperacion } from 'app/models/FiltrosOperacion';
import { SessionStorageService } from '../../storage/sessionStorage.service';
import { Observable } from "rxjs";
import { filter, pluck } from "rxjs/operators";
import { LocalService } from '../../storage/localService';

@Injectable({
  providedIn: 'root'
})

export class OperacionService {

  readonly urlBase =  environment.rutaBase;

  header : HttpHeaders;
  message: Observable<any>;
  idEmpresa_Factor : any;
  dataConfirming : any; 
  constructor( private http : HttpClient,  private accesoService :AccesoService, private sessionStorageService: SessionStorageService,private localService : LocalService) {

     this.header = this.accesoService.desencriptarTOKEN();  
     this.datoStorage()
  }

   datoStorage(){
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
   this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
   if (this.idEmpresa_Factor == undefined) {
    this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
   } 
  }
  FiltroListadoConfirming(Filtros : FiltrosOperacion, fechaD:any, fechaH:any){
     
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `jJQx8YRGVmJlZWp9DNXC58gm4Yi8Nz`);
    return this.http.get(`https://apilx.starkengine.com/Api-Contratos/public/api-contrato/ObtenerConfirming?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&IdConfirming=${Filtros.IdOperacion}&cEstado=${Filtros.Estado}&IdAdquirente=${Filtros.IdAd}&cDesde=${fechaD}&cHasta=${fechaH}&CodOperacion=${Filtros.CodOperacion}`,{headers});    
  }
  obtenerOperacionByConfirming(IdAd : any,CodOperacion:any){
     
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `jJQx8YRGVmJlZWp9DNXC58gm4Yi8Nz`);
    return this.http.get(`https://apilx.starkengine.com/Api-Contratos/public/api-contrato/ObtenerOperacionesConfirming?idEmpresa_Factor=${this.idEmpresa_Factor}&IdAdquirente=${IdAd}&CodOperacion=${CodOperacion}`,{headers});    
  }
  guardarOperacionConfirming(body :any){
     
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `jJQx8YRGVmJlZWp9DNXC58gm4Yi8Nz`);
    return this.http.post(`https://apilx.starkengine.com/Api-Contratos/public/api-contrato/GenerarOperacionesConfirming?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});    
  }
  BajaOperacionConfirming(body :any){
     
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `jJQx8YRGVmJlZWp9DNXC58gm4Yi8Nz`);
    return this.http.put(`https://apilx.starkengine.com/Api-Contratos/public/api-contrato/BajaEstadoOperacionConfirming?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});  
     
  }
  
  altaOperacionConfirming(body :any){
     
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `jJQx8YRGVmJlZWp9DNXC58gm4Yi8Nz`);
    return this.http.put(`https://apilx.starkengine.com/Api-Contratos/public/api-contrato/AltaOperacionConfirming?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});  
     
  }
  
  FiltroListadoOperacion(Filtros : FiltrosOperacion, fechaD:any, fechaH:any){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Operacion?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&IdOperacion=${Filtros.IdOperacion}&cEstado=${Filtros.Estado}&IdProveedor=${Filtros.Id}&IdAdquirente=${Filtros.IdAd}&cDesde=${fechaD}&cHasta=${fechaH}&CodOperacion=${Filtros.CodOperacion}`,{headers});    
  }

  ObtenerOperacionPorId(idOperacion: number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/OperacionPorId?idEmpresa_Factor=${this.idEmpresa_Factor}&idOperacion=${idOperacion}`,{headers})
  }
  
  ObtenerOperacionDet(idOperacion:number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/OperacionDet?idEmpresa_Factor=${this.idEmpresa_Factor}&idOperacion=${idOperacion}`,{headers})
  }

  ObtenerOperacionDetalle(idOperacion:number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/OperacionDetalle?idEmpresa_Factor=${this.idEmpresa_Factor}&idOperacion=${idOperacion}`,{headers})
  }

  guardarOperacion(body :any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/Operacion?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
  }

  actualizarEstado(body:any,idOperacion? : any){
    let headers = this.header;
    return this.http.put(`${this.urlBase}/OperacionEstado?idEmpresa_Factor=${this.idEmpresa_Factor}&idOperacion=${idOperacion}`,body,{headers});
  }

    BajaOperacion(body:any){
    let headers = this.header;
    return this.http.put(`${this.urlBase}/BajaEstadoOperacion?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
  }

  notificarSoliDes(body : any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/KeynuaReenviarSolicitudDes?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
  }

  //Lista las operaciones para crear desembolsos
  obtenerOperacionSoliDes(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/OperacionSolicitudD?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&`,{headers});   
  }
}  